module.exports = __webpack_public_path__ + "img/T20.eb254562.jpg";